module.exports = __webpack_public_path__ + "static/img/19097B_1_R_20200820_fit.ef5f0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19097B_1_R_20200820_fit.png
// module id = lPTK
// module chunks = 0